import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "config/store";
import { useEffect } from "react";
import { Translate } from "react-jhipster";
import { IEdoCoursePost } from "shared/model/edo-course-post.model";
import { deleteEntity } from "shared/reducers/entities/edo-course-post.reducer";
import { EntityState } from "shared/reducers/reducer.utils";

interface IDeleteCoursePostProps {
    post: IEdoCoursePost;
    open: boolean;
    onClose: () => void;
}

const DeleteCoursePostDialog = (props: IDeleteCoursePostProps) => {
    const dispatch = useAppDispatch();
    const { updateSuccess } = useAppSelector<EntityState<IEdoCoursePost>>((state) => state.edoCoursePost);

    const { open, onClose: handleClose, post } = props;

    const confirmDelete = () => {
        dispatch(deleteEntity(post.id));
    };

    useEffect(() => {
        if (updateSuccess) {
            handleClose();
        }
    }, [updateSuccess]);

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>
                <Translate contentKey="entity.delete.title" />
            </DialogTitle>
            {!post ? (
                <CircularProgress
                    size={24}
                    style={{ marginLeft: 15, position: "relative", top: 4 }}
                />
            ) : (
                <DialogContent>
                    <DialogContentText>
                        <Translate contentKey="edocendoApp.edoCoursePost.delete.question" />
                    </DialogContentText>
                </DialogContent>
            )}
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    <Translate contentKey="entity.action.cancel" />
                </Button>
                <Button onClick={confirmDelete} color="primary">
                    <Translate contentKey="entity.action.delete" />
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteCoursePostDialog;